import { Injectable } from '@angular/core';
import { Subject, filter, fromEvent, map, merge } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {

  get isOnline$ () {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true))
    )
  }

  constructor() { }

}
